import { render, staticRenderFns } from "./GameBuddyBooking.vue?vue&type=template&id=81ca3ff2&scoped=true"
import script from "./GameBuddyBooking.vue?vue&type=script&lang=js"
export * from "./GameBuddyBooking.vue?vue&type=script&lang=js"
import style0 from "./GameBuddyBooking.vue?vue&type=style&index=0&id=81ca3ff2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81ca3ff2",
  null
  
)

export default component.exports